import { langEnum } from "../../config/constants";

export const langData = [
    {
        lang: langEnum.ARM,
        img: 'https://www.dropbox.com/s/17ednsvv1g1zqwz/Armenia.png?raw=1'
    },
    {
        lang: langEnum.ENG,
        img: 'https://www.dropbox.com/s/8jitn6qimvs8xzm/us.png?raw=1'
    },
    {
        lang: langEnum.RUS,
        img: 'https://www.dropbox.com/s/zg2uh3cygh2keyb/rus.png?raw=1'
    }
]